import api from '@/services/api';
import introJS from 'intro.js/intro';

const getTour = async number => {
  try {
    return await api.get(`api/user/tours/${number}`, {});
  } catch (error) {
    return null;
  }
};

const setTourViewed = async number => {
  try {
    return await api.post(`api/user/tours/${number}/visualizado`, {});
  } catch (error) {
    return null;
  }
};

const getSteps = async data => {
  const steps = [{
    title: data.titulo,
    intro: data.descricao,
  }].concat(data.items.map(item => ({
    element: item.elemento,
    intro: item.texto,
    title: data.titulo,
    callback_pre: item.callback_pre,
    callback_pos: item.callback_pos,
  })));

  return steps;
};

const loadTourPage = async program => {
  const tour = await getTour(program);
  if (tour && tour.data.data.status == 'A') {
    const options = await {
      doneLabel: 'Pronto',
      nextLabel: 'Próximo',
      prevLabel: 'Anterior',
      showProgress: true,
      steps: await getSteps(tour.data.data),
    };

    const intro = introJS()
      .setOptions(options);

    intro
      .onbeforechange(function () {
        /* eslint-disable no-underscore-dangle */
        const etapa = this._currentStep;
        if (etapa >= 0) {
          if (options.steps[etapa].callback_pre) {
            /* eslint-disable no-eval */
            eval(options.steps[etapa].callback_pre);
          }
        }
      })
      .onafterchange(function () {
        /* eslint-disable no-underscore-dangle */
        const etapa = this._currentStep;
        const etapaAnterior = etapa - 1;
        if (etapaAnterior >= 0) {
          if (options.steps[etapaAnterior].callback_pos) {
            /* eslint-disable no-eval */
            eval(options.steps[etapaAnterior].callback_pos);
          }
        }
      })
      .oncomplete(() => {
        if (options.steps[options.steps.length - 1].callback_pos) {
          eval(options.steps[options.steps.length - 1].callback_pos);
        }
        setTourViewed(tour.data.data.recnum);
      })
      .start();
  }
};

export default loadTourPage;
